module.exports = __webpack_public_path__ + "img/Singapore-hover.8f6ccfa8.jpg";